import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/queries/query-keys';
import { adminsApi } from '@/lib/api';

/**
 * POST /admins/invite — the one real mutation in TDEV-141. On success we
 * invalidate the roster so the genuinely-created pending invitation appears in
 * the Invitations table (GET /admins now returns invitations live).
 */
export function useInviteAdmin() {
  const queryClient = useQueryClient();
  return useMutation<{ success: boolean }, Error, { email: string; roleIds: string[] }>({
    mutationFn: ({ email, roleIds }) => adminsApi.invite(email, roleIds),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.admins.roster });
    },
  });
}
